/* eslint-disable */
import * as Types from '../../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type OrganisationEInvoiceSettingsBox_ViewerOrganisationFragment = { __typename: 'ViewerOrganisation', id: string, eInvoiceSettings: { __typename: 'OrganisationEInvoiceSettings', enabled: boolean, format?: Types.EInvoiceFormat | null, validationStatus: { __typename: 'OrganisationEInvoiceValidationStatus', canEnable: boolean, missingFields: Array<string> } } };

export type OrganisationEInvoiceSettingsBox_OrganisationFragment = { __typename: 'Organisation', id: string, eInvoiceSettings: { __typename: 'OrganisationEInvoiceSettings', enabled: boolean, format?: Types.EInvoiceFormat | null, validationStatus: { __typename: 'OrganisationEInvoiceValidationStatus', canEnable: boolean, missingFields: Array<string> } } };

export type OrganisationEInvoiceSettingsBox_UpdateOrganisationEInvoiceSettingsMutationVariables = Types.Exact<{
  input: Types.UpdateOrganisationEInvoiceSettingsInput;
}>;


export type OrganisationEInvoiceSettingsBox_UpdateOrganisationEInvoiceSettingsMutation = { updateOrganisationEInvoiceSettings: { __typename: 'UpdateOrganisationEInvoiceSettingsResult', organisation: { __typename: 'Organisation', id: string, eInvoiceSettings: { __typename: 'OrganisationEInvoiceSettings', enabled: boolean, format?: Types.EInvoiceFormat | null, validationStatus: { __typename: 'OrganisationEInvoiceValidationStatus', canEnable: boolean, missingFields: Array<string> } } } } };

export const OrganisationEInvoiceSettingsBox_ViewerOrganisationFragmentDoc = gql`
    fragment OrganisationEInvoiceSettingsBox_ViewerOrganisation on ViewerOrganisation {
  id
  eInvoiceSettings {
    enabled
    format
    validationStatus {
      canEnable
      missingFields
    }
  }
}
    `;
export const OrganisationEInvoiceSettingsBox_OrganisationFragmentDoc = gql`
    fragment OrganisationEInvoiceSettingsBox_Organisation on Organisation {
  id
  eInvoiceSettings {
    enabled
    format
    validationStatus {
      canEnable
      missingFields
    }
  }
}
    `;
export const OrganisationEInvoiceSettingsBox_UpdateOrganisationEInvoiceSettingsDocument = gql`
    mutation OrganisationEInvoiceSettingsBox_UpdateOrganisationEInvoiceSettings($input: UpdateOrganisationEInvoiceSettingsInput!) {
  updateOrganisationEInvoiceSettings(input: $input) {
    organisation {
      id
      ...OrganisationEInvoiceSettingsBox_Organisation
    }
  }
}
    ${OrganisationEInvoiceSettingsBox_OrganisationFragmentDoc}`;
export type OrganisationEInvoiceSettingsBox_UpdateOrganisationEInvoiceSettingsMutationFn = Apollo.MutationFunction<OrganisationEInvoiceSettingsBox_UpdateOrganisationEInvoiceSettingsMutation, OrganisationEInvoiceSettingsBox_UpdateOrganisationEInvoiceSettingsMutationVariables>;

/**
 * __useOrganisationEInvoiceSettingsBox_UpdateOrganisationEInvoiceSettingsMutation__
 *
 * To run a mutation, you first call `useOrganisationEInvoiceSettingsBox_UpdateOrganisationEInvoiceSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganisationEInvoiceSettingsBox_UpdateOrganisationEInvoiceSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organisationEInvoiceSettingsBoxUpdateOrganisationEInvoiceSettingsMutation, { data, loading, error }] = useOrganisationEInvoiceSettingsBox_UpdateOrganisationEInvoiceSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOrganisationEInvoiceSettingsBox_UpdateOrganisationEInvoiceSettingsMutation(baseOptions?: Apollo.MutationHookOptions<OrganisationEInvoiceSettingsBox_UpdateOrganisationEInvoiceSettingsMutation, OrganisationEInvoiceSettingsBox_UpdateOrganisationEInvoiceSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrganisationEInvoiceSettingsBox_UpdateOrganisationEInvoiceSettingsMutation, OrganisationEInvoiceSettingsBox_UpdateOrganisationEInvoiceSettingsMutationVariables>(OrganisationEInvoiceSettingsBox_UpdateOrganisationEInvoiceSettingsDocument, options);
      }
export type OrganisationEInvoiceSettingsBox_UpdateOrganisationEInvoiceSettingsMutationHookResult = ReturnType<typeof useOrganisationEInvoiceSettingsBox_UpdateOrganisationEInvoiceSettingsMutation>;
export type OrganisationEInvoiceSettingsBox_UpdateOrganisationEInvoiceSettingsMutationResult = Apollo.MutationResult<OrganisationEInvoiceSettingsBox_UpdateOrganisationEInvoiceSettingsMutation>;
export type OrganisationEInvoiceSettingsBox_UpdateOrganisationEInvoiceSettingsMutationOptions = Apollo.BaseMutationOptions<OrganisationEInvoiceSettingsBox_UpdateOrganisationEInvoiceSettingsMutation, OrganisationEInvoiceSettingsBox_UpdateOrganisationEInvoiceSettingsMutationVariables>;